import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import { exec, Request } from '@kakaopay-common/payweb-bridge';

const execWrapper = <T>(command: Request) => {
  return exec<T>(snakecaseKeys(command, { deep: true })).then((response: T) =>
    camelcaseKeys(response, { deep: true })
  );
};

export default execWrapper;
